import React, { useState, useEffect } from 'react';
import { cuplAPI } from '../context/api';
import './CUPLTable.css'; // Reutilizar estilos de tabla

const BypassSoatModal = ({ isOpen, onClose, onBypassSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [cupls, setCupls] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');
  const [actioning, setActioning] = useState(false);

  useEffect(() => {
    if (isOpen) {
      fetchNoSoatCupls();
      setSelectedIds([]);
      setReason('');
      setError('');
    }
  }, [isOpen]);

  const fetchNoSoatCupls = async () => {
    setLoading(true);
    try {
      const response = await cuplAPI.getCuplsWithoutSoat();
      setCupls(response.data);
    } catch (err) {
      console.error(err);
      setError('Error al obtener la lista de CUPLs sin SOAT.');
    } finally {
      setLoading(false);
    }
  };

  const handleSelect = (id) => {
    setSelectedIds(prev => 
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedIds(cupls.map(c => c.id));
    } else {
      setSelectedIds([]);
    }
  };

  const handleSubmit = async () => {
    if (selectedIds.length === 0) return;
    setActioning(true);
    setError('');
    try {
      for (const id of selectedIds) {
        await cuplAPI.bypassSoat(id, reason);
      }
      alert('✅ CUPLs habilitados para pago exitosamente.');
      onBypassSuccess();
      onClose();
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || 'Error al habilitar los CUPLs sin SOAT.');
    } finally {
      setActioning(false);
    }
  };

  const formatDateOnly = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    const localDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
    return localDate.toLocaleDateString('es-CO');
  };

  const isExpired = (expirationDate) => {
    if (!expirationDate) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const expDate = new Date(expirationDate);
    const localExpDate = new Date(expDate.getTime() + expDate.getTimezoneOffset() * 60000);
    localExpDate.setHours(0, 0, 0, 0);
    return localExpDate < today;
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()} style={{ maxWidth: '800px', width: '90%' }}>
        <div className="modal-header">
          <h3>⚠️ Habilitar Trámites para Pago sin SOAT</h3>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>
        
        <div className="modal-body" style={{ maxHeight: '65vh', overflowY: 'auto', padding: '20px' }}>
          {error && <div className="error-banner" style={{ marginBottom: '15px', color: '#dc2626', backgroundColor: '#fef2f2', padding: '10px', borderRadius: '6px', border: '1px solid #fee2e2' }}>{error}</div>}
          
          <p style={{ color: '#475569', marginBottom: '15px', fontSize: '14px' }}>
            Los siguientes CUPLs cargados están ocultos de la bandeja porque sus vehículos no registran un SOAT aprobado. Selecciona los que desees forzar como <strong>disponibles para pago</strong>.
          </p>

          {loading ? (
            <p style={{ textAlign: 'center', padding: '20px' }}>Cargando CUPLs sin SOAT...</p>
          ) : cupls.length === 0 ? (
            <p style={{ textAlign: 'center', padding: '30px', color: '#64748b', fontWeight: '500' }}>
              🎉 No hay trámites pendientes de SOAT que requieran omisión.
            </p>
          ) : (
            <>
              <div className="table-responsive">
                <table className="cupl-table" style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
                <thead>
                  <tr style={{ background: '#f8fafc', borderBottom: '2px solid #e2e8f0' }}>
                    <th style={{ padding: '10px', textAlign: 'left' }}>
                      <input 
                        type="checkbox" 
                        checked={selectedIds.length === cupls.length}
                        onChange={handleSelectAll}
                      />
                    </th>
                    <th style={{ padding: '10px', textAlign: 'left' }}>CUPL</th>
                    <th style={{ padding: '10px', textAlign: 'left' }}>Placa</th>
                    <th style={{ padding: '10px', textAlign: 'left' }}>Trámite</th>
                    <th style={{ padding: '10px', textAlign: 'left' }}>Monto</th>
                    <th style={{ padding: '10px', textAlign: 'left' }}>Vencimiento</th>
                  </tr>
                </thead>
                <tbody>
                  {cupls.map(cupl => (
                    <tr key={cupl.id} style={{ borderBottom: '1px solid #f1f5f9', background: isExpired(cupl.expiration_date) ? '#fef2f2' : 'none' }}>
                      <td style={{ padding: '10px' }}>
                        <input 
                          type="checkbox" 
                          checked={selectedIds.includes(cupl.id)}
                          onChange={() => handleSelect(cupl.id)}
                        />
                      </td>
                      <td style={{ padding: '10px', fontWeight: '500' }}>{cupl.cupl_number}</td>
                      <td style={{ padding: '10px' }}><span className="plate" style={{ display: 'inline' }}>{cupl.plate}</span></td>
                      <td style={{ padding: '10px' }}>{cupl.tramite_name}</td>
                      <td style={{ padding: '10px' }}>${(cupl.total_amount || cupl.tramite_value)?.toLocaleString('es-CO')}</td>
                      <td style={{ padding: '10px', color: isExpired(cupl.expiration_date) ? '#dc2626' : '#475569', fontWeight: isExpired(cupl.expiration_date) ? 'bold' : 'normal' }}>
                        {formatDateOnly(cupl.expiration_date)}
                        {isExpired(cupl.expiration_date) && <span style={{ fontSize: '9px', backgroundColor: '#fee2e2', padding: '2px 4px', borderRadius: '4px', marginLeft: '5px' }}>Vencida</span>}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              </div>

              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', fontWeight: '600', marginBottom: '5px', fontSize: '14px', color: '#334155' }}>
                  Motivo de la Omisión (Se guardará en el historial):
                </label>
                <textarea 
                  placeholder="Ej: Cliente autorizó pago sin SOAT / Verificación manual física" 
                  value={reason} 
                  onChange={(e) => setReason(e.target.value)}
                  style={{ width: '100%', height: '60px', padding: '8px', border: '1px solid #cbd5e1', borderRadius: '6px', fontSize: '14px', fontFamily: 'inherit' }}
                />
              </div>
            </>
          )}
        </div>

        <div className="modal-footer" style={{ padding: '15px 20px', borderTop: '1px solid #e2e8f0', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
          <button onClick={onClose} className="btn-secondary" style={{ padding: '8px 16px', borderRadius: '6px', cursor: 'pointer' }}>
            Cancelar
          </button>
          <button 
            onClick={handleSubmit} 
            className="btn-primary" 
            disabled={selectedIds.length === 0 || actioning}
            style={{ padding: '8px 16px', borderRadius: '6px', cursor: 'pointer', backgroundColor: '#ea580c', borderColor: '#ea580c' }}
          >
            {actioning ? '⏳ Procesando...' : `Habilitar Seleccionados (${selectedIds.length})`}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BypassSoatModal;
